import React, { useState } from "react"

// eslint-disable-next-line import/prefer-default-export
export const useInput = (initValue: string) => {
    const [value, setValue] = useState(initValue)
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setValue(e.target.value)
    }
    return [value, handleChange] as const
}
